
<template>
  <div class="firstClassify" :class="{ isIosx: isIosx, noAppNav: !isToken }">
    <van-sticky>
      <div class="firstClassifyNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">{{ title }}</span>
        <img
          v-if="isToken"
          class="navRight"
          @click="share()"
          src="./../../assets/school/sfh.png"
        />
      </div>
    </van-sticky>
    <div class="firstClassifyContent">
      <div class="contentItem" v-for="(item, index) of dataList" :key="index">
        <div
          class="contentItemTop"
          @click="toSecondClassify(item.title, item.children, -1)"
        >
          <div class="contentItemTopLeft">
            <img :src="item.image" alt="" />
            <span>{{ item.title }}</span>
          </div>
          <div class="contentItemTopRight">
            <img src="./../../assets/school/right.png" alt="" />
          </div>
        </div>
        <div class="contentItemConten">
          <span
            v-for="(i, j) of item.children"
            :key="j"
            @click="toSecondClassify(item.title, item.children, i.id)"
            >{{ i.title }}</span
          >
        </div>
      </div>
    </div>
    <SfBtm :mobile="mobile" v-if="!isToken && mobile"></SfBtm>
    <span class="shareTip" v-if="!isToken && mobile"
      >{{ mobile.substring(0, 3) + "****" + mobile.substring(7) }}的分享</span
    >
  </div>
</template>

<script>
import SfBtm from "./components/sfBtm.vue";
export default {
  data() {
    return {
      title: "",
      isIosx: false,
      dataList: [],
      api_category_id: 0,
      isToken: true,
      classifylUrl: "",
      mobile: "",
    };
  },
  components: { SfBtm },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.classifylUrl = "school/member/given/trees";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getMobile();
    } else {
      this.isToken = false;
      this.classifylUrl = "school/index/given/trees";
      if (this.$route.query.mobile) {
        this.mobile = this.$route.query.mobile;
        sessionStorage.setItem("mobile", this.mobile);
      } else {
        this.mobile = sessionStorage.getItem("mobile");
      }
    }
    if (this.$route.query.api_category_id) {
      this.api_category_id = this.$route.query.api_category_id;
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
    }
    this.getThree();
  },
  methods: {
    // 返回
    prev() {
      this.$router.go(-1);
    },
    // 获取分类
    getThree() {
      this.$api
        .get(this.classifylUrl, {
          api_category_id: this.api_category_id,
        })
        .then((res) => {
          this.dataList = res.children;
        });
    },
    // 跳转二级分类
    toSecondClassify(title, data, id) {
      let activeId = -2;
      if (id == -1) {
        if (!data || data.length == 0) {
          activeId = -1;
        } else {
          activeId = -2;
        }
      } else {
        activeId = id;
      }
      this.$router.push({
        path: "/school/secondClassify",
        query: {
          title: title,
          navList: JSON.stringify(data),
          activeId: activeId,
        },
      });
    },
    // 获取会员手机号
    getMobile() {
      this.$api.get("school/member/share/mobile").then((res) => {
        this.mobile = res.mobile;
      });
    },
    // 分享
    share() {
      // 获取手机号
      this.$api.post("school/index/business/school/get/share").then((res) => {
        let title = res.small_title;
        let bigTitle = res.big_title;
        let thumb = res.image;
        let url = `${location.href}&mobile=${this.mobile}`;
        let paramAndroid = [bigTitle, title, url, thumb];
        let paramIos = [title, bigTitle, url, thumb];
        this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.firstClassify {
  min-height: 100%;
  background: #f7f8fc;
  /* overflow: auto; */
}
.firstClassifyNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.firstClassifyNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.firstClassifyNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.firstClassifyNav .navRight {
  position: absolute;
  right: 16px;
  bottom: 5px;
  width: 40px;
  height: 31px;
}
/* content */
.firstClassifyContent {
  margin: 0 16px;
  padding-bottom: 16px;
  .contentItem {
    background-color: #ffffff;
    border-radius: 8px;
    margin-top: 16px;
    padding: 24px 17px;
    .contentItemTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .contentItemTopLeft {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #404247;
          line-height: 20px;
        }
      }
      .contentItemTopRight {
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
    .contentItemConten {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 8px 5px 0;
      span {
        width: 30%;
        height: 48px;
        background-color: #f7f8fc;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 400;
        color: #6e727a;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
      }
    }
    .contentItemConten:after {
      content: "";
      width: 30%;
      height: 0px;
      visibility: hidden;
    }
  }
}
.isIosx .firstClassifyNav {
  padding-top: 44px;
}
.noAppNav .firstClassifyNav {
  padding-top: 15px !important;
}
.noAppNav .firstClassifyContent {
  padding-bottom: 86px;
}
.shareTip {
  position: fixed;
  top: 7px;
  right: 0;
  padding: 8px 16px 8px 24px;
  background: rgba(14, 14, 14, 0.36);
  border-radius: 18px 0px 0px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  z-index: 999;
}
</style>